import { render, staticRenderFns } from "./MembershipItem.vue?vue&type=template&id=4b9a6490"
import script from "./MembershipItem.vue?vue&type=script&lang=js"
export * from "./MembershipItem.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/youtube/yt-live-chat-membership-item-renderer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports